<template>
    <div id="map" ref="map"></div>
</template>

<script>
import MarkerClusterer from "@google/markerclustererplus";
import { Loader } from "@googlemaps/js-api-loader";
import { computed } from "vue";
import API_URL from "../../../../helpers/apiUrls";
export default {
    name: "customMapFarmer",
    data() {
        return {
            map: null,
            scale: 0,
            viewBounds: null,
            zoom: 4,
            center: { lat: 20.745, lng: 78.523 },
            location: [],
            markers: [],
            heatMapData: [
                new google.maps.LatLng(8.8678, 76.5623),
                new google.maps.LatLng(9.5674, 77.5623),
                new google.maps.LatLng(10.7821, 78.447),
                new google.maps.LatLng(12.4523, 79.443),
                new google.maps.LatLng(37.782, -122.441),
                new google.maps.LatLng(37.782, -122.439),
                new google.maps.LatLng(37.782, -122.435),
                new google.maps.LatLng(37.785, -122.447),
                new google.maps.LatLng(37.785, -122.445),
                new google.maps.LatLng(37.785, -122.441),
                new google.maps.LatLng(37.785, -122.437),
                new google.maps.LatLng(37.785, -122.435),
            ],
        };
    },
    watch: {
        zoom: function (val) {
            console.log("zoom ", val);
            //this.displayMap2()
            this.map.setZoom(this.zoom);
        },
        center: function (val) {
            const center = new google.maps.LatLng(val.lat, val.lng);
            // using global variable:
            //setTimeout(() => {
            this.map.panTo(center);
            //}, 500);

            console.log("location ", val);
        },
    },
    mounted() {
        const apiOptions = {
            apiKey: process.env.VUE_APP_GMAP_KEY,
        };

        const loader = new Loader(apiOptions);

        loader.load().then(() => {
            console.log("Maps JS API loaded");
            const map = this.displayMap();
            this.map = map;

            const markers = this.addMarkers(map);
            //this.clusterMarkers(map, markers);
            setTimeout(() => {
                this.getMapScale();
                this.getViewBounds();
                this.addPolygon();
                this.getZoomLevel();
                //this.setHeatMap()
            }, 1000);
        });
    },
    methods: {
        displayMap() {
            const mapOptions = {
                center: this.center,
                zoom: this.zoom,
                scaleControl: true,
                zoomControl: true,
                minZoom: 4,
                mapTypeControl: true,
                zIndex: 1,
                maxZoom: 16,
                streetViewControl: false,
            };
            const mapDiv = document.getElementById("map");
            const map = new google.maps.Map(mapDiv, mapOptions);
            const drawingManager = new google.maps.drawing.DrawingManager({
                drawingControl: false,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: [
                        google.maps.drawing.OverlayType.MARKER,
                        google.maps.drawing.OverlayType.CIRCLE,
                        google.maps.drawing.OverlayType.POLYGON,
                        google.maps.drawing.OverlayType.POLYLINE,
                        google.maps.drawing.OverlayType.RECTANGLE,
                    ],
                },
                markerOptions: {
                    icon: require("../../../../../src/assets/mapImages/circle.svg"),
                },
                circleOptions: {
                    fillColor: "#ffff00",
                    fillOpacity: 1,
                    strokeWeight: 5,
                    clickable: false,
                    editable: true,
                    zIndex: 1,
                },
            });

            drawingManager.setMap(map);
            google.maps.event.addListener(
                drawingManager,
                "overlaycomplete",
                function (polygon) {
                    console.log("event", polygon);
                    var polygonBounds = polygon.overlay.getPath();
                    var bounds = [];
                    var latlng = [];
                    var latlngObj = [];
                    for (var i = 0; i < polygonBounds.length; i++) {
                        var point = {
                            lat_lng:
                                polygonBounds.getAt(i).lat() +
                                "," +
                                polygonBounds.getAt(i).lng(),
                            lng: polygonBounds.getAt(i).lng(),
                        };

                        bounds.push(point);
                    }
                    console.log("bounds", bounds);
                }
            );
            map.addListener("zoom_changed", (e) => {
                // 3 seconds after the center of the map has changed, pan back to the
                // marker.

                if (this.removeMarkers()) {
                    setTimeout(() => {
                        this.getViewBounds(map);
                        // this.getMapScale();
                        this.getZoomLevel();

                        console.log("oom_changed");
                    }, 800);

                    // this.setMarkerCluster([])
                    // this.setMarkerCluster(this.markerPoint)
                }
            });
            map.addListener("dragend", (e) => {
                this.getViewBounds();
                this.getZoomLevel();
                this.getMapScale();
                //this.setHeatMap();

                console.log("center changed_changed", e);
            });

            return map;
        },
        setDrawingOptions(map) {
            const drawingManager = new google.maps.drawing.DrawingManager({
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: [
                        google.maps.drawing.OverlayType.MARKER,
                        google.maps.drawing.OverlayType.CIRCLE,
                        google.maps.drawing.OverlayType.POLYGON,
                        google.maps.drawing.OverlayType.POLYLINE,
                        google.maps.drawing.OverlayType.RECTANGLE,
                    ],
                },
                markerOptions: {
                    icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
                },
                circleOptions: {
                    fillColor: "#ffff00",
                    fillOpacity: 1,
                    strokeWeight: 5,
                    clickable: false,
                    editable: true,
                    zIndex: 1,
                },
            });

            drawingManager.setMap(map);
        },
        // displayMap() {
        //     const mapOptions = {
        //         center: { lat: -33.860664, lng: 151.208138 },
        //         zoom: 14,
        //         scaleControl: true,
        //     };
        //     const mapDiv = document.getElementById("map");
        //     const map = new google.maps.Map(mapDiv, mapOptions);
        //     ``;
        //     const drawingManager = new google.maps.drawing.DrawingManager({
        //         // drawingMode: google.maps.drawing.OverlayType.MARKER,
        //         // drawingMode: google.maps.drawing.OverlayType.POLYGON,

        //         drawingControl: true,
        //         drawingControlOptions: {
        //             position: google.maps.ControlPosition.TOP_CENTER,
        //             drawingModes: [
        //                 google.maps.drawing.OverlayType.MARKER,
        //                 google.maps.drawing.OverlayType.CIRCLE,
        //                 google.maps.drawing.OverlayType.POLYGON,
        //                 google.maps.drawing.OverlayType.POLYLINE,
        //                 google.maps.drawing.OverlayType.RECTANGLE,
        //             ],
        //         },
        //         markerOptions: {
        //             icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
        //         },
        //         circleOptions: {
        //             fillColor: "#ffff00",
        //             fillOpacity: 1,
        //             strokeWeight: 5,
        //             clickable: false,
        //             editable: true,
        //             zIndex: 1,
        //         },
        //     });

        //     drawingManager.setMap(map);
        //     google.maps.event.addListener(
        //         drawingManager,
        //         "overlaycomplete",
        //         function (polygon) {
        //             console.log("event", polygon);
        //             var polygonBounds = polygon.overlay.getPath();
        //             var bounds = [];
        //             var latlng = [];
        //             var latlngObj = [];
        //             for (var i = 0; i < polygonBounds.length; i++) {
        //                 var point = {
        //                     lat_lng:
        //                         polygonBounds.getAt(i).lat() +
        //                         "," +
        //                         polygonBounds.getAt(i).lng(),
        //                     lng: polygonBounds.getAt(i).lng(),
        //                 };

        //                 bounds.push(point);
        //             }
        //             console.log("bounds", bounds);
        //         }
        //     );
        //     map.addListener("zoom_changed", (e) => {
        //         // 3 seconds after the center of the map has changed, pan back to the
        //         // marker.
        //         this.getViewBounds();
        //         // this.getMapScale();
        //         //this.markerClusterer.clearMarkers();
        //         //this.setMarkerCluster(this.location);
        //         console.log("oom_changed");
        //     });

        //     return map;
        // },
        getMapScale() {
            setTimeout(() => {
                var spnList = document
                    .getElementById("map")
                    .getElementsByTagName("span");
                var pattern = /\d+\s+(m|km)/i;
                console.log("spnList", spnList);
                for (var i in spnList) {
                    if (pattern.test(spnList[i].innerText)) {
                        this.scale = spnList[i].innerText;
                        console.log("spn", spnList[i].innerText);
                    }
                }
            }, 600);
        },
        getViewBounds() {
            let bounds = this.map?.getBounds();
            let neBunds = bounds?.getNorthEast();
            let swBounds = bounds?.getSouthWest();

            let top_left = [
                parseFloat(swBounds?.lng()),
                parseFloat(neBunds?.lat()),
            ];
            let bottom_right = [
                parseFloat(neBunds?.lng()),
                parseFloat(swBounds?.lat()),
            ];

            const view_bounds = {
                top_left: top_left,
                bottom_right: bottom_right,
            };
            console.log("bounds", map, bounds, view_bounds);
            this.viewBounds = view_bounds;

            return view_bounds;
        },
        addMarkers(locations) {
            this.removeMarkers();
            this.location = [];
            this.markerPoint = [];
            const markers = [];
            locations.map((item) => {
                //console.log("location", item);
                const label = item.count.toString();
                const markerOptions = item.is_clustered
                    ? {
                          map: this.map,
                          position: item.location,
                          icon: require("../../../../../src/assets/mapImages/m1.png"),
                          label: label,
                      }
                    : {
                          map: this.map,
                          position: item.location,
                          icon: require("../../../../../src/assets/mapImages/circle.svg"),
                          zIndex: 1,
                      };
                console.log();
                const marker = new google.maps.Marker(markerOptions);
                if (!item.is_clustered) {
                    marker.addListener("click", (e) => {
                        console.log("click", item);
                        if (!item.is_clustered) {
                            const data = this.createUserContentForInfoWindow(
                                item,
                                item.user.id
                            );
                            console.log("=======>", data);
                        }

                        //  this.setInfoWindow(item, data);
                    });
                }
                markers.push(marker);
            });

            console.log("markers", markers);
            this.markerPoint = markers;
            return markers;
        },
        async removeMarkers() {
            for (var i = 0; i < this.markerPoint.length; i++) {
                this.markerPoint[i].setMap(null);
            }

            return true;
        },
        clusterMarkers(markers) {
            console.log("markerCluster", markers);
            const clustererOptions = {
                zoomOnClick: true,
                styles: [
                    {
                        url: require("../../../../assets/mapImages/m1.png"),
                    },
                    {
                        url: require("../../../../assets/mapImages/m2.png"),
                    },
                    {
                        url: require("../../../../assets/mapImages/m3.png"),
                    },
                    {
                        url: require("../../../../assets/mapImages/m4.svg"),
                    },
                    {
                        url: require("../../../../assets/mapImages/m5.svg"),
                    },
                ],
            };

            const markerCluster = new MarkerClusterer(
                this.map,
                markers,
                clustererOptions
            );

            //this.markerClusterer=markerCluster
            console.log("markerCluster", markerCluster);
        },

        addPolygon() {
            const myPolygon = new google.maps.Polygon({
                paths: this.location,

                options: {
                    fillColor: "ffff00",
                    fillOpacity: 0,
                    strokeColor: "#989898",
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    clickable: false,
                    draggable: false,
                    editable: false,
                    geodesic: false,
                    zIndex: 1,
                },
            });
            myPolygon.setMap(this.map);
        },
        getZoomLevel() {
            let zoom = this.map.zoom;
            this.zoom = zoom;
            this.$emit("getBounds", this.viewBounds, zoom);
            console.log("oom level", zoom);
        },
        setMarkerCluster(location) {
            const markers = this.addMarkers(location);
            console.log("markers", markers, location);
            // this.clusterMarkers(markers);
        },
        setInfoWindow(position, data) {
            console.log("setInfoWindowData", data);
            const infowindow = new google.maps.InfoWindow({
                content: data,
                position: position.location,
            });

            infowindow.open(this.map);
            setTimeout(function () {
                infowindow.close();
            }, 4000);
            //this.createUserContentForInfoWindow(position.user.id);
        },
        createUserContentForInfoWindow(obj, id) {
            this.toggleLoader(true);
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log("getMapLocationPerson", response.data);

                    this.toggleLoader(false);

                    let data =
                        `<p> Name : ${response.data.user.full_name} </p> ` +
                        "" +
                        `${
                            response.data.user.address != "null,null" &&
                            response.data.user.address != null
                                ? `<p>Address: ${response.data.user.address}</p>`
                                : ""
                        }`;
                    console.log("window", data);
                    this.setInfoWindow(obj, data);
                    return data;
                }
            };

            const errorHandler = (error) => {
                this.showToast(
                    "Something went wrong internally!",
                    "error",
                    10000
                );
                console.log(error);
                this.toggleLoader(false);
            };

            this.requestGET(
                `${API_URL.getUserDetails_map}?user_id=${id}`,
                {},
                {},
                successHandler,
                errorHandler,
                process.env.VUE_APP_API_BASE_URL_DISCOVERY,
                300000
            );
        },
    },
};
</script>

<style scoped>
#map {
    height: calc(100vh - 120px);
}
</style>